/**
 * Created by guoguangyu on 2016/10/25.
 * Improved by Nate
 */
import React from "react";
import PropTypes from "prop-types";
import * as jsondiffpatch from "jsondiffpatch";
import formatters from "jsondiffpatch/src/main-formatters";

require("jsondiffpatch/public/formatters-styles/html.css");
require("jsondiffpatch/public/formatters-styles/annotated.css");

const JsonDiffReact = props => {
  const { right, left, annotated, tips } = props;
  const delta = jsondiffpatch.diff(left, right);
  const html = annotated
    ? formatters.annotated.format(delta)
    : formatters.html.format(delta, left);

  return html ? (
    // eslint-disable-next-line
    <div dangerouslySetInnerHTML={{ __html: html }} />
  ) : (
    <p style={{ fontSize: 12, color: "#999" }}>{tips}</p>
  );
};
JsonDiffReact.propTypes = {
  // eslint-disable-next-line
  right: PropTypes.object.isRequired,
  // eslint-disable-next-line
  left: PropTypes.object.isRequired,
  annotated: PropTypes.bool,
  tips: PropTypes.string
};
JsonDiffReact.defaultProps = {
  annotated: false,
  tips: ""
};
export default JsonDiffReact;
